module.exports = __webpack_public_path__ + "static/media/sliders-v.93dbe362.svg";